module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.step === 1) ? _c('section', {
    staticClass: "content cleafix"
  }, [_c('form', [_c('h1', {
    staticClass: "form-head"
  }, [_vm._v("\n        用户登录\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "用户名：邮箱或手机号",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": [function($event) {
        _vm.validateUsername()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.username))])]), _vm._v(" "), (_vm.type === 1) ? _c('div', {
    staticClass: "input-item clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 clearfix"
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-sm-7 n-p-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.verifyCode),
      expression: "verifyCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "验证码：6位"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "blur": [function($event) {
        _vm.validateCode()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 n-p-r n-p-l"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "type": "button",
      "disabled": _vm.code.disabled
    },
    on: {
      "click": function($event) {
        _vm.sendVerifyCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.code.text))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.code))])])])]) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "密码：6-16位字符、数字、特殊字符",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": [function($event) {
        _vm.validatePassword()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.password))])]) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "reg-now m-t-b-xs clearfix"
  }, [(_vm.type === 1) ? _c('span', {
    staticClass: "right color-default",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.type = 2
      }
    }
  }, [_vm._v("使用密码登录")]) : _vm._e(), _vm._v(" "), (_vm.type === 2) ? _c('span', {
    staticClass: "right color-default",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.type = 1
      }
    }
  }, [_vm._v("使用验证码登录")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-item clearfix"
  }, [_c('input', {
    staticClass: "btn btn-md btn-primary col-xs-12 login-btn",
    attrs: {
      "type": "button",
      "value": "登    录"
    },
    on: {
      "click": function($event) {
        _vm.userLogin()
      }
    }
  })]), _vm._v(" "), (_vm.type === 2) ? _c('h5', {
    staticClass: "reg-now m-t-b-sm"
  }, [_vm._v("还没有帐号?\n          "), _c('router-link', {
    staticClass: "color-primary ",
    attrs: {
      "to": {
        name: '/auth/register',
        params: {}
      }
    }
  }, [_vm._v("马上注册")]), _vm._v(" "), _c('router-link', {
    staticClass: "color-primary right",
    attrs: {
      "to": {
        name: '/auth/reset_password',
        params: {}
      }
    }
  }, [_vm._v("忘记密码?")])], 1) : _vm._e(), _vm._v(" "), (_vm.type === 1) ? _c('h5', {
    staticClass: "reg-now m-t-b-sm"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "init-content"
  }, [_c('div', {
    staticClass: "step-content"
  }, [_c('form', {
    staticClass: "company-info"
  }, [_c('h1', {
    staticClass: "form-head"
  }, [_vm._v("完善个人信息")]), _vm._v(" "), _c('div', {
    staticClass: "input-item m-b"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": _vm.user.nickname,
      "src": _vm.user.avatar
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hidden-file",
    attrs: {
      "type": "file",
      "name": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadAvatar($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-item show-info text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.nickname),
      expression: "user.nickname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "用户昵称：乐橙谷",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.nickname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.nickname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.realname),
      expression: "user.realname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "真实姓名：华宇互联",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.realname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.qq),
      expression: "user.qq",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "QQ：10000",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.qq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.qq = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.signature),
      expression: "user.signature",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input textarea",
    attrs: {
      "resize": "none",
      "placeholder": "个性签名：人在江湖飘，就是要挨刀！",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.signature)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.signature = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "type": "button",
      "value": "完善信息"
    },
    on: {
      "click": function($event) {
        _vm.completeInfo()
      }
    }
  })])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "third-plat  m-t-b-sm"
  }, [_c('span', [_vm._v("使用其他平台登录")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "third-plats  clearfix"
  }, [_c('a', {
    staticClass: "third-login-btn",
    attrs: {
      "href": "/api/v1/auth/lechenggu"
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/lechenggu.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "third-login-btn",
    attrs: {
      "href": "/api/v1/auth/weibo"
    }
  }, [_c('img', {
    attrs: {
      "src": "/assets/images/weibo.png",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32deb3e4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/login.vue
// module id = 473
// module chunks = 1